import { cn } from '../../lib/utils';
import { StepMarker, type StepState } from './stepper';

/**
 * A horizontal counterpart to {@link Stepper}: numbered markers in a row joined
 * by connectors, labels beneath. Same visual language (active spins, done fills
 * with the brand green) — used for compact, inline staged progress.
 */
export function StepProgress({
  steps,
  className,
  spinActive = true,
}: {
  steps: { label: string; state: StepState }[];
  className?: string;
  /** When false, the active marker is a highlighted number rather than a spinner. */
  spinActive?: boolean;
}) {
  return (
    <ol className={cn('flex items-start', className)}>
      {steps.map((step, i) => (
        <li key={i} className="flex flex-1 flex-col items-center text-center">
          <div className="flex w-full items-center">
            <span
              className={cn(
                'h-0.5 flex-1 rounded-full',
                i === 0 ? 'bg-transparent' : step.state === 'pending' ? 'bg-hairline' : 'bg-iris',
              )}
            />
            <StepMarker index={i + 1} state={step.state} spin={spinActive} />
            <span
              className={cn(
                'h-0.5 flex-1 rounded-full',
                i === steps.length - 1
                  ? 'bg-transparent'
                  : step.state === 'done'
                    ? 'bg-iris'
                    : 'bg-hairline',
              )}
            />
          </div>
          <span
            className={cn(
              'mt-2 px-1 text-xs leading-tight transition-colors',
              step.state === 'active'
                ? 'font-semibold text-bone'
                : step.state === 'pending'
                  ? 'text-muted'
                  : 'text-haze',
            )}
          >
            {step.label}
          </span>
        </li>
      ))}
    </ol>
  );
}
